var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapGrayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1968_25473",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1968_25473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99845 11.8089C8.22344 11.8089 6.77344 10.3672 6.77344 8.5839C6.77344 6.80052 8.22344 5.36719 9.99845 5.36719C11.7735 5.36719 13.2235 6.80885 13.2235 8.59223C13.2235 10.3756 11.7735 11.8089 9.99845 11.8089ZM9.99845 6.61719C8.91512 6.61719 8.02344 7.50052 8.02344 8.59223C8.02344 9.6839 8.90679 10.5672 9.99845 10.5672C11.0901 10.5672 11.9735 9.6839 11.9735 8.59223C11.9735 7.50052 11.0818 6.61719 9.99845 6.61719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 18.968C8.76801 18.968 7.52637 18.5013 6.5597 17.5763C4.10137 15.2096 1.3847 11.4346 2.4097 6.94297C3.3347 2.86797 6.89303 1.04297 10.0013 1.04297C10.0013 1.04297 10.0013 1.04297 10.0097 1.04297C13.118 1.04297 16.6763 2.86797 17.6013 6.9513C18.618 11.443 15.9013 15.2096 13.443 17.5763C12.4763 18.5013 11.2347 18.968 10.0013 18.968ZM10.0013 2.29297C7.57637 2.29297 4.4597 3.58464 3.6347 7.21797C2.7347 11.143 5.20137 14.5263 7.4347 16.668C8.87634 18.0596 11.1347 18.0596 12.5763 16.668C14.8013 14.5263 17.268 11.143 16.3847 7.21797C15.5513 3.58464 12.4263 2.29297 10.0013 2.29297Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGrayIcon);
export default __webpack_public_path__ + "static/media/map_gray_icon.615311bdfc304b2b2e40ae23fec5b7fd.svg";
export { ForwardRef as ReactComponent };